import { EColors, EFonts } from "libs/style/w24_styling"
import React from "react"
import styled from "styled-components/macro"

interface Props {
  children: React.ReactNode
  className?: string
}

export const T1 = (props: Props): JSX.Element => {
  return <S_T1 className={props.className}>{props.children}</S_T1>
}

const S_T1 = styled.div`
  color: ${EColors.DARK};
  font-family: ${EFonts.Medium2};
  font-size: 15px;
  line-height: 28px;
  @media only screen and (min-width: 1260px) {
    font-size: 18px;
    line-height: 37px;
  }
`
